import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { updateEmailTree } from '../../../../../Features/letterBox/api/emailTree';
import EmailThread from '../EmailThread';
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FormGroup, Input, Label } from 'reactstrap';
import { AppDispatch, RootState } from '../../../../../ReduxToolkit/Store';
import { LI, P, UL } from '../../../../../AbstractElements';
import { handleEnvelope, handleInterview } from '../../../../../ReduxToolkit/Reducers/LetterBoxReducer';
import MailPagination from './Pagination';
import DashboardSvgIcon from '../../../../../Utils/CommonComponents/DashboardSvgIcon';
import { fieldEmail, letterBoxListResult, LetterDetailResponse } from "../../../../../Features/letterBox/api/types";
import { toggleFavouriteEmail } from "../../../../../Features/letterBox/api/letterBox.api";

type LetterBoxNavContentType = {
  listEmail: fieldEmail[];
  n_pages: number;
  isLoading: boolean;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  onDeleteIds: (ids: number[]) => void;
};

export default function InboxTab({
    listEmail,
    n_pages,
    isLoading,
    selectedIds,
    setSelectedIds,
    onDeleteIds,
}:LetterBoxNavContentType) {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const queryClient = useQueryClient();
    const [optimisticFav, setOptimisticFav] = useState<Record<number, 0 | 1>>({});
    const { faIcon } = useSelector((state: RootState) => state.email);
    const handleRemoveEmail = (id: number) => {
        const confirmed = window.confirm("Confermi l'eliminazione dell'email?");
        if (!confirmed) return;
        onDeleteIds([id]);
        setSelectedIds((prev) => prev.filter((itemId) => itemId !== id));
    };

    const toggleSelected = (id: number, checked: boolean) => {
        setSelectedIds((prev) => {
            if (checked) return prev.includes(id) ? prev : [...prev, id];
            return prev.filter((itemId) => itemId !== id);
        });
    };

    const favouriteMutation = useMutation({
        mutationFn: (payload: { id: number; isFavourite: boolean }) =>
          toggleFavouriteEmail(payload.id, payload.isFavourite),
        onMutate: async ({ id, isFavourite }) => {
            await queryClient.cancelQueries({ queryKey: ["letterBox-list"], exact: false });
            const previous = queryClient.getQueriesData<letterBoxListResult>({ queryKey: ["letterBox-list"] });
            const nextValue: 0 | 1 = isFavourite ? 0 : 1;
            setOptimisticFav((prev) => ({ ...prev, [id]: nextValue }));
            queryClient.setQueriesData<letterBoxListResult>({ queryKey: ["letterBox-list"], exact: false }, (old) => {
                if (!old) return old;
                return {
                    ...old,
                    list: updateEmailTree(old.list, id, { favourite: nextValue }),
                };
            });
            return { previous, previousOptimistic: optimisticFav };
        },
        onError: (_error, _vars, context) => {
            context?.previous?.forEach(([key, data]) => {
                queryClient.setQueryData(key, data);
            });
            if (context?.previousOptimistic) {
                setOptimisticFav(context.previousOptimistic);
            }
        },
        onSuccess: (_res, { id, isFavourite }) => {
            queryClient.setQueriesData<letterBoxListResult>({ queryKey: ["letterBox-list"], exact: false }, (old) => {
                if (!old) return old;
                return {
                    ...old,
                    list: updateEmailTree(old.list, id, { favourite: isFavourite ? 0 : 1 }),
                };
            });
            setOptimisticFav((prev) => {
                const { [id]: _removed, ...rest } = prev;
                return rest;
            });
        },
    });

    const renderRow = (item: fieldEmail, threadToggle?: React.ReactNode) => (
<LI
                      key={item.id}
                      style={item.typeID === 2 ? { backgroundColor: "#ffffe9" } : item.is_read === 0 ? { backgroundColor: "#e8f4ff" } : undefined}
                      onClick={() => navigate(`${process.env.PUBLIC_URL || ""}/gestione-email/${item.id}`)}
                    >
                        <div className="inbox-user" style={{ minWidth: 0, flexShrink: 0, marginRight: 16 }}>
                            {threadToggle}
                            <FormGroup className="m-0" check inline>
                                <Input
                                  name="emailCheckbox"
                                  id={`emailCheckbox${item.id}`}
                                  type="checkbox"
                                  checked={selectedIds.includes(item.id)}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) => toggleSelected(item.id, e.target.checked)}
                                />
                                <Label check htmlFor={`emailCheckbox${item.id}`} />
                            </FormGroup>
                            <DashboardSvgIcon
                              className={`important-mail ${(optimisticFav[item.id] ?? item.favourite) ? "active" : ""}`}
                              iconId="fill-star"
                              onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                const current = optimisticFav[item.id] ?? item.favourite;
                                favouriteMutation.mutate({ id: item.id, isFavourite: current === 1 });
                              }}
                            />
                        {item.ticketID && (<span className="text-nowrap" style={{ cursor: "text", userSelect: "text" }} onClick={event => event.stopPropagation()} onDoubleClick={event => event.stopPropagation()}>{item.ticketID}</span>)}
                        </div>
                        <div className="inbox-message" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                            <div className="email-data" style={{ flex: 1, minWidth: 0 }}>
                                <span>
                                    {item.subject}
                                    
                                </span>
                                    <P className="mb-0 text-truncate">{item.from_email}</P>
                            
                            </div>
                            {item.progettoID != null && item.attivitaID != null && item.progettoID > 0 && item.attivitaID > 0 && (
                                <Link
                                    className="btn btn-sm btn-outline-primary text-nowrap"
                                    style={{ flexShrink: 0, alignSelf: "center" }}
                                    to={`${process.env.PUBLIC_URL || ''}/progetti/${item.progettoID}/${item.attivitaID}`}
                                    onClick={event => event.stopPropagation()}
                                >
                                    Vai al task
                                </Link>
                            )}
                            <div className="email-timing" style={{ flexShrink: 0, justifyContent: "flex-end", whiteSpace: "nowrap" }}><span>{item.data_ins}</span></div>
                            <div className="email-options">
                                <i className={`fa-regular fa-envelope envelope-1 ${!faIcon ? "show" : "hide"}`} onClick={(e) => { e.stopPropagation(); dispatch(handleEnvelope(true)); }} />
                                {/* <i className={`fa-solid fa-envelope-open-text envelope-2 ${faIcon ? "show" : "hide"}`} onClick={(e) => { e.stopPropagation(); dispatch(handleEnvelope(false)); }} /> */}
                                <i className="fa-solid fa-trash-can trash-3" onClick={(e) => { e.stopPropagation(); handleRemoveEmail(item.id); }} />
                                {/* <i className="fa-solid fa-print" onClick={(e) => e.stopPropagation()} /> */}
                            </div>
                            {item.typeID === 2 && (
                                <span className="text-primary d-inline-flex align-items-center" style={{ flexShrink: 0 }} title="Inviata da noi" role="img" aria-label="Inviata da noi">
                                    <i className="fa-solid fa-paper-plane" aria-hidden="true" />
                                </span>
                            )}
                        </div>
                    </LI>
    );

    if (isLoading) return <p className='p-5'>Caricamento in corso</p>;

    return (
        <div className="mail-body-wrapper">
            <div className="d-flex align-items-center justify-content-start flex-wrap gap-2 px-3 py-2 small" aria-label="Legenda email">
                <span aria-hidden="true" style={{ backgroundColor: "#e8f4ff", width: 16, height: 16, border: "1px solid #c6dff5", borderRadius: 3, flexShrink: 0 }} />
                <span>Da leggere</span>
                <span aria-hidden="true" className="ms-3" style={{ backgroundColor: "#ffffe9", width: 16, height: 16, border: "1px solid #e0e0a9", borderRadius: 3, flexShrink: 0 }} />
                <span>Inviati</span>
            </div>
            <UL className='simple-list'>
                {listEmail.map(item => <EmailThread key={item.id} email={item} renderRow={renderRow} />)}
            </UL>
            <MailPagination n_pages={n_pages} />
        </div>
    )
}
